import { render, staticRenderFns } from "./PaymentMethodsChart.vue?vue&type=template&id=3cd6283f"
import script from "./PaymentMethodsChart.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports